<template>
    <section class="c-enterprise-features">
        <div class="c-enterprise-features--loaded">
            <div class="c-enterprise-features__content">
                <ul class="features-list">
                    <li
                        v-for="(item, index) in content.albums"
                        :key="item.id"
                        class="list-item"
                    >
                        <div
                            v-if="index === 1"
                            class="list-item__svg-container"
                        >
                            <img
                                src="@/assets/images/enterprise-features-arrow.svg"
                                alt=""
                                class="enterprise-features-img"
                            >
                        </div>
                        <div class="list-item__content">
                            <div class="content-text">
                                <h2 class="content-text__title">
                                    {{ item.title }}
                                </h2>
                                <p
                                    v-for="(text, textCount) in splitAndRemoveNewlines(item.description)"
                                    :key="`feature-${index}-${textCount}`"
                                    class="content-text__description"
                                >
                                    <img
                                        src="@/modules/mvp/assets/tick.png"
                                        :alt="text"
                                        class="stack-tick"
                                    >
                                    <span>
                                        {{ text }}
                                    </span>
                                </p>
                            </div>
                            <div class="content-icon">
                                <img
                                    :src="imgSrc(item)"
                                    :alt="item.title"
                                    class="enterprise-feature-icon"
                                >
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'EnterpriseFeatures',
        props: {
            content: Object,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {};
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,

            /**
             * Split the string into an array using "\n" as the separator
             *
             * @param {string} text
             * @returns {*[]}
             */
            splitAndRemoveNewlines(text) {
                return text.split('\\n');
            },
        },
    };

</script>

<style lang="scss" src="./index.scss"/>
